import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PinAuthService } from '../services/auth/pin-auth.service';

/**
 * Гуард, который не позволяет заходить на страницу настройки пин-кода,
 * если пин-код уже установлен.
 */
export const pinSetupAccessGuard: CanActivateFn = async () => {
  const pinAuthService = inject(PinAuthService);
  const router = inject(Router);

  const isPinSet = await pinAuthService.isPinSet();

  if (isPinSet) {
    if (pinAuthService.isAuthenticated()) {
      return router.createUrlTree(['/mining']);
    }

    return router.createUrlTree(['/pin-auth']);
  }

  return true;
};
